jQuery(document).ready(function($){

    $('[data-copy-url]').on('click', function() {
        let url = window.location.href;
        let $icon = $(this).find('i');

        navigator.clipboard.writeText(url);

        $icon.removeClass('icon-link').addClass('icon-check');

        setTimeout(() => {
            $icon.removeClass('icon-check').addClass('icon-link');
        }, 1000);
    });

});
